<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App'
  };
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #505050;
  dispaly:flex;
  text-align:center;
  align-items: center;
  justify-content: center; /*水平居中*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue